import styles from './styles.module.scss'

const SmartTrackingImage = () => {
    return <div className={`${styles['smart-tracking-image']}`}></div>
}

export default SmartTrackingImage
